export default "__VITE_ASSET__CtZXmFu7__"